module.exports = __webpack_public_path__ + "static/wickidcool-logo-89cf5b49d14c4df2da8473ac6a6184dc.png";